import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChartsModule } from 'ng2-charts';

import { GraphSharedComponent } from './graph.component';

@NgModule({
    declarations: [
        GraphSharedComponent
    ],
    imports: [
        CommonModule,
        ChartsModule
    ],
    exports: [
        GraphSharedComponent
    ]
})

export class GraphSharedModule {}
